/* eslint-disable react-hooks/exhaustive-deps */
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useSnackbar } from "notistack";
import { InputAdornment } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Image } from "antd";
import useApiRequest from "utils/Apirequest";
import { useMaterialUIController } from "context";
import { allowVehicleText, allowOnlyAlphanumeric, allowOnlyAlphanumericAndSpace } from "utils/Constant";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

function UpdateVehicle() {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [previewImage, setPreviewImage] = useState("");
  const [connectorTypeShow] = useState(["CCS2", "Type6", "Type2", "Type7"]);
  const apiRequest = useApiRequest();
  const [initialData, setInitialData] = useState({});
  const row_data = location.state || {};
  const [previewOpen, setPreviewOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const getInitialValues = () => ({
    registeration_number: initialData.vehicle_reg || "",

    make: initialData.make || "",
    model: initialData.model || "",
    variant: initialData.variant || "",
    batterycapacity: initialData.battery_capacity || "",
    connector_type: initialData.connector_type || "",
    range: initialData.claimed_range || "",
    vehicleImage: initialData.image || [],
  });
  const [values, setValues] = useState(getInitialValues({}));
  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setValues(getInitialValues(initialData));
    }
  }, [initialData]);

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handlePreviewClose = () => {
    setPreviewImage("");
    setPreviewOpen(false);
  };

  const getValue = async () => {
    const { data } =
      (await apiRequest("get", "vehicle/" + row_data, null, {}, {}, false)) ||
      {};

    if (data?.success === true) {
      setInitialData(data?.data);
    }
  };

  useEffect(() => {
    getValue();
  }, [row_data]);

  const createUser = async (fileList) => {
    const payload = {
      type: "4-Wheeler",
      make: values.make,
      model: values.model,
      variant: values.variant,
      claimed_range: values.range,
      battery_capacity: values.batterycapacity,
      connector_type: values.connector_type,
      vehicle_reg: values.registeration_number,
    };

    const { data } =
      (await apiRequest(
        "put",
        "vehicle/" + row_data,
        payload,
        {},
        { "Content-Type": "application/json" }
      )) || {};

    if (data?.success === true) {
      navigate("/vehicle");
      // window.location.reload();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const newErrors = {
      make: !values.make
        ? "Make is required"
        : !allowVehicleText(values.make)
          ? "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed."
          : "",

      model: !values.model
        ? "Model is required"
        : !allowVehicleText(values.model)
          ? "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed."
          : "",

      variant: !values.variant
        ? "Variant is required"
        : !allowVehicleText(values.variant)
          ? "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed."
          : "",

      batterycapacity: !values.batterycapacity
        ? "Battery Capacity is required"
        : "",

      range: !values.range
        ? "Range is required"
        : "",

      connector_type: !values.connector_type
        ? "Connector Type is required"
        : "",
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(Boolean)) {
      enqueueSnackbar("Please fix validation errors", { variant: "error" });
      return;
    }

    createUser();
  };

  const reset = (event) => {
    event.preventDefault();
    setValues(getInitialValues());
    setErrors({});
  };

  return (
    <>
      {" "}
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => {
              setPreviewOpen(visible);
              if (!visible) handlePreviewClose();
            },
            afterOpenChange: (visible) => {
              if (!visible) handlePreviewClose();
            },
          }}
          src={previewImage}
        />
      )}
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={1}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow={sidenavColor}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h6" color="white">
                    Vehicle information
                  </MDTypography>

                  <IconButton
                    onClick={() => navigate("/vehicle")}
                    sx={{ color: "#fff" }}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </MDBox>

                <MDBox pt={0} pb={0} px={3}>
                  <MDBox pt={0}></MDBox>

                  <MDBox p={2} component="form" role="form">
                    <MDBox p={1}>
                      <MDInput
                        type="text"
                        label="Registeration number"
                        value={values.registeration_number}
                        name="registeration_number"
                        margin="dense"
                        fullWidth={true}
                        onChange={handleChange}
                        disabled
                        InputProps={{
                          sx: {
                            backgroundColor: darkMode ? "#202940" : "#f0f2f5",
                            color: darkMode ? "#ffffff" : "#000000",
                            "& .MuiInputBase-input.Mui-disabled": {
                              backgroundColor: darkMode ? "#202940" : "#f0f2f5",
                            },
                          },
                        }}
                        onBlur={(e) => {
                          const value = e.target.value;

                          setErrors((prev) => ({
                            ...prev,
                            registeration_number: allowOnlyAlphanumeric(value)
                              ? ""
                              : "Only letters and numbers are allowed",
                          }));
                        }}
                        error={Boolean(errors.registeration_number)}
                        helperText={errors.registeration_number}
                        FormHelperTextProps={{
                          sx: {
                            color: "#d32f2f",
                            fontSize: "12px",
                            marginLeft: "4px",
                          },
                        }}
                      />
                    </MDBox>

                    <MDBox p={1}>
                      <MDInput
                        type="text"
                        label="Make"
                        value={values.make}
                        name="make"
                        margin="dense"
                        fullWidth={true}
                        onChange={handleChange}
                        onBlur={(e) => {
                          const value = e.target.value;

                          setErrors((prev) => ({
                            ...prev,
                            make: allowVehicleText(value)
                              ? ""
                              : "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed.",
                          }));
                        }}
                        error={Boolean(errors.make)}
                        helperText={errors.make}
                        FormHelperTextProps={{
                          sx: {
                            color: "#d32f2f",
                            fontSize: "12px",
                            marginLeft: "4px",
                          },
                        }}
                      />
                    </MDBox>

                    <MDBox p={1}>
                      <MDInput
                        type="text"
                        label="Model"
                        value={values.model}
                        name="model"
                        margin="dense"
                        fullWidth={true}
                        onChange={handleChange}
                        onBlur={(e) => {
                          const value = e.target.value;

                          setErrors((prev) => ({
                            ...prev,
                            model: allowVehicleText(value)
                              ? ""
                              : "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed.",
                          }));
                        }}
                        error={Boolean(errors.model)}
                        helperText={errors.model}
                        FormHelperTextProps={{
                          sx: {
                            color: "#d32f2f",
                            fontSize: "12px",
                            marginLeft: "4px",
                          },
                        }}
                      />
                    </MDBox>

                    <MDBox p={1}>
                      <MDInput
                        type="text"
                        label="Variant"
                        value={values.variant}
                        name="variant"
                        margin="dense"
                        fullWidth={true}
                        onChange={handleChange}
                        onBlur={(e) => {
                          const value = e.target.value;
                          setErrors((prev) => ({
                            ...prev,
                            variant: allowVehicleText(value)
                              ? ""
                              : "Only letters, numbers, spaces, and . , & ( ) ' + - / are allowed.",
                          }));
                        }}
                        error={Boolean(errors.variant)}
                        helperText={errors.variant}
                        FormHelperTextProps={{
                          sx: {
                            color: "#d32f2f",
                            fontSize: "12px",
                            marginLeft: "4px",
                          },
                        }}
                      />
                    </MDBox>
                    <MDBox p={1}>
                      <MDInput
                        type="text"
                        label="Battery Capacity"
                        value={values.batterycapacity}
                        name="batterycapacity"
                        margin="dense"
                        fullWidth={true}
                        onChange={handleChange}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Typography
                                variant="body2"
                                style={{ fontSize: "16px", fontWeight: "bold" }}
                              >
                                kW
                              </Typography>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MDBox>
                    <MDBox p={1}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-multiple-name-label">
                          Connector Type
                        </InputLabel>
                        <Select
                          sx={{
                            height: 50,
                          }}
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          placeholder="Select Connector Type"
                          value={values.connector_type}
                          name="connector_type"
                          onChange={handleChange}
                          input={<OutlinedInput label="connectorType" />}
                        >
                          {connectorTypeShow.map((name, index) => (
                            <MenuItem key={index} value={name}>
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </MDBox>

                    <MDBox p={1}>
                      <MDInput
                        type="number"
                        label="Range"
                        value={values.range}
                        name="range"
                        margin="dense"
                        fullWidth={true}
                        onChange={handleChange}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Typography
                                variant="body2"
                                style={{ fontSize: "16px", fontWeight: "bold" }}
                              >
                                KM
                              </Typography>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MDBox>

                    <Grid
                      container
                      direction="row"
                      justifyContent="space-around"
                      p={2}
                    >
                      <MDButton
                        variant="gradient"
                        color={sidenavColor}
                        onClick={reset}
                      >
                        Reset
                      </MDButton>
                      <MDButton
                        variant="gradient"
                        color={sidenavColor}
                        onClick={handleSubmit}
                      >
                        Submit
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </DashboardLayout>
    </>
  );
}

export default UpdateVehicle;
